import {Component, OnInit, ViewChild} from '@angular/core';
import {Customer, CustomerService} from '../../customer.service';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {NotificationService} from '../../notification.service';
import {GlobalValidator} from '../../global-validator';
import {Observable} from 'rxjs/Observable';
import {ServerService, Server} from '../../server.service';
import {SelectComponent} from 'ng2-select';
import {DatePipe} from '@angular/common';
import {LicenseService, License, LicenseState} from '../../license.service';
import {defineLocale} from 'ngx-bootstrap/chronos';
import {ptBrLocale} from 'ngx-bootstrap/locale';
import {BsLocaleService} from 'ngx-bootstrap';

@Component({
  selector: 'app-customer-edit',
  templateUrl: './customer-edit.component.html',
  styleUrls: ['./customer-edit.component.css']
})
export class CustomerEditComponent implements OnInit {

  public formGroup: FormGroup;

  public licenseFormGroup: FormGroup;

  public billingFormGroup: FormGroup;

  disableSubmit = false;

  loading = false;

  editing = false;

  invalidId = false;

  formErrors = {};

  licenseFormErrors = {};

  billingFormErrors = {};

  actualData = new Customer('', '', new Array<string>());

  servers = new Array<String>();

  licenseEnabled = false;

  billingEnabled = false;

  activeData = [];

  @ViewChild('select') selectServers: SelectComponent;

  validationMessages = {
    'id': {
      'required': 'Id não informada',
      'incorrectIdFormat': 'Id inválida'
    },
    'name': {
      'required': 'Nome não informado'
    },
    'licenseQuantity': {
      'nonInteger': 'Quantidade inválida',
      'required': 'Quantidade não informada'
    },
    'extensionsQuantity': {
      'nonInteger': 'Quantidade inválida',
      'required': 'Quantidade não informada'
    },
    'administratorsQuantity': {
      'nonInteger': 'Quantidade inválida',
      'required': 'Quantidade não informada'
    },
    'usersQuantity': {
      'nonInteger': 'Quantidade inválida',
      'required': 'Quantidade não informada'
    }
  };

  constructor(private fb: FormBuilder, private cs: CustomerService, public router: Router, public route: ActivatedRoute,
              public ns: NotificationService, private ss: ServerService, private datePipe: DatePipe,
              private ls: LicenseService, private localeService: BsLocaleService) {
  }

  buildForm() {
    this.formGroup = this.fb.group({
      'id': ['', [Validators.required, GlobalValidator.validIdValidator]],
      'name': ['', Validators.required],
      'servers': ['']
    });
    this.licenseFormGroup = this.fb.group({
      'enableLicense': [false],
      'licenseQuantity': [0, [Validators.required, GlobalValidator.intValueValidator]],
      'licenseExpiration': ['']
    });
    this.billingFormGroup = this.fb.group({
      'enableBilling': [false],
      'extensionsQuantity': [0, [Validators.required, GlobalValidator.intValueValidator]],
      'usersQuantity': [0, [Validators.required, GlobalValidator.intValueValidator]],
      'administratorsQuantity': [0, [Validators.required, GlobalValidator.intValueValidator]],
      'licenseExpiration': ['']
    });
  }

  trySave(model, isValid: boolean) {
    if (!isValid) {
      return;
    }
    this.actualData.id = model.id;
    this.actualData.name = model.name;
    this.loading = true;
    this.disableSubmit = true;
    this.cs.save(this.actualData).subscribe((c) => {
        console.log(`Customer saved successfully: ${JSON.stringify(c)}`);
        this.loading = false;
        this.disableSubmit = false;
        this.ns.success(this.actualData.id, 'Salvo com sucesso');
        this.formGroup.reset();
        this.selectServers.active = [];
        this.buildForm();
        if (this.editing) {
          this.router.navigateByUrl('/customers');
        } else {
          this.router.navigateByUrl('/customers/' + this.actualData.id);
        }
      },
      (error: any) => {
        console.log(`Error saving server!! ${JSON.stringify(error)}`);
        this.ns.error(error.toString(), 'Erro ao salvar');
        this.loading = false;
      });
    return;
  }

  createLicense(customerId: string, name: string, enabled: boolean, quantity: any, expiration: Date): License {
    const license = new License(name, customerId, 'default', 0, {'value': 0}, null);
    license.value = {'number': +quantity};
    license.expiration = (new Date(expiration)).getTime();
    if (isNaN(license.expiration)) {
      license.expiration = 0;
    }
    license.setLicenseState(enabled ? LicenseState.VALID : LicenseState.DISABLED);
    console.log(`license: ${JSON.stringify(license)}`);
    return license;
  }

  trySaveLicense(model, isValid: boolean) {
    if (!isValid) {
      return;
    }
    this.loading = true;
    this.disableSubmit = true;
    const customerId = this.formGroup.get('id').value;
    console.log(`model:${JSON.stringify(model)}`);
    const licWebDialer = this.createLicense(customerId, 'webDialer', model.enableLicense, model.licenseQuantity, model.licenseExpiration);
    const licUsers = this.createLicense(customerId, 'users', model.enableLicense, model.licenseQuantity, model.licenseExpiration);
    Observable.concat(this.ls.save(licUsers), this.ls.save(licWebDialer)).subscribe((lic: License) => {
      console.log(`License saved successfully: ${JSON.stringify(lic)}`);
      this.loading = false;
      this.disableSubmit = false;
      this.ns.success(this.actualData.id + ' ' + lic.name, 'Salvo com sucesso');
    }, (error: any) => {
      console.log(`Error saving license!! ${JSON.stringify(error)}`);
      if (error.message) {
        this.ns.error(error.message, 'Erro ao salvar a licença!!');
      } else {
        this.ns.error('Erro...', 'Erro ao salvar a licença!!');
      }
      this.loading = false;
    });
  }

  trySaveBilling(model: any, isValid: boolean) {
    if (!isValid) {
      return;
    }
    this.loading = true;
    this.disableSubmit = true;
    const customerId = this.formGroup.get('id').value;
    console.log(`model:${JSON.stringify(model)}`);
    const licBillingExtensions = this.createLicense(customerId, 'billing_extensions',
      model.enableBilling, model.extensionsQuantity, model.licenseExpiration);
    const licBillingAdministrators = this.createLicense(customerId, 'billing_administrators',
      model.enableBilling, model.administratorsQuantity, model.licenseExpiration);
    const licBillingUsers = this.createLicense(customerId, 'billing_users',
      model.enableBilling, model.usersQuantity, model.licenseExpiration);
    Observable.concat(this.ls.save(licBillingExtensions), this.ls.save(licBillingAdministrators), this.ls.save(licBillingUsers))
      .subscribe((lic: License) => {
        console.log(`License saved successfully: ${JSON.stringify(lic)}`);
        this.loading = false;
        this.disableSubmit = false;
        this.ns.success(this.actualData.id + ' ' + lic.name, 'Salvo com sucesso');
      }, (error: any) => {
        console.log(`Error saving license!! ${JSON.stringify(error)}`);
        if (error.message) {
          this.ns.error(error.message, 'Erro ao salvar a licença!!');
        } else {
          this.ns.error('Erro...', 'Erro ao salvar a licença!!');
        }
        this.loading = false;
      });
  }

  getServersIds() {
    this.ss.getAll()
      .map((servers: Array<Server>) => servers.map((server: Server) => server.id))
      .subscribe((ids: Array<String>) => this.servers = ids);
  }

  setServers(data: Array<any>) {
    const actualServers = new Array<string>();
    data.forEach((serverId) => {
      console.log(`Adding ServerId: ${JSON.stringify(serverId.id)}`);
      actualServers.push(serverId.id);
    });
    console.log(`setting servers to: ${JSON.stringify(actualServers)}`);
    this.actualData.servers = actualServers;
  }

  ngOnInit() {
    defineLocale('pt-br', ptBrLocale);
    this.localeService.use('pt-br');
    this.buildForm();
    // console.log(`${JSON.stringify(this.route.params)}`);
    this.route.params.switchMap((params: Params) => {
      const id = params['id'];
      console.log(`Loading data for id:${id}`);
      if (id) {
        return Observable.from([id]);
      } else {
        return Observable.from(['']);
      }
    }).subscribe((id: string) => {
      this.getCustomerByID(id).subscribe((c: Customer) => this.updateCustomer(c));
      this.getLicenseByID(id).subscribe((licenses: Array<License>) => this.updateLicenses(licenses));
    });
    this.formGroup.valueChanges.debounceTime(500).subscribe((data) => this.onValueChanges(data));
    this.licenseFormGroup.valueChanges.debounceTime(100).subscribe((data) => this.onLicenseValueChanges(data));
    this.billingFormGroup.valueChanges.debounceTime(100).subscribe((data) => this.onBillingValueChanges(data));
    this.getServersIds();
  }

  getCustomerByID(id: string): Observable<Customer> {
    if (id && id !== '') {
      this.editing = true;
      return this.cs.findById(id);
    } else {
      return Observable.from([new Customer('', '', new Array<string>())]);
    }
  }

  updateCustomer(c: Customer): void {
    this.actualData = c;
    this.formGroup.controls['id'].patchValue(c.id);
    this.formGroup.controls['name'].patchValue(c.name);
    this.selectServers.active = c.servers;
  }

  getLicenseByID(id: string): Observable<Array<License>> {
    if (id && id !== '') {
      this.editing = true;
      return this.ls.getAll(id);
    } else {
      return Observable.from([[new License('', '', '', 0, {}, 'DISABLED')]]);
    }
  }

  updateLicenses(licenses: Array<License>): void {
    // WebDialer
    const webDialerLicense = this.findLicense('users', licenses);
    const billingExtensionsLicense = this.findLicense('billing_extensions', licenses);
    const billingAdministratorsLicense = this.findLicense('billing_administrators', licenses);
    const billingUsersLicense = this.findLicense('billing_users', licenses);
    if (webDialerLicense) {
      this.licenseFormGroup.controls['enableLicense'].setValue(webDialerLicense.getLicenseState() === LicenseState.VALID);
      this.licenseFormGroup.controls['licenseQuantity'].setValue(webDialerLicense.value['number']);
      if (webDialerLicense.expiration !== 0) {
        this.licenseFormGroup.controls['licenseExpiration']
          .patchValue(new Date(webDialerLicense.expiration));
      }
    }
    if (billingExtensionsLicense && billingAdministratorsLicense && billingUsersLicense) {
      this.billingFormGroup.controls['enableBilling']
        .setValue(billingExtensionsLicense.getLicenseState() === LicenseState.VALID);
      this.billingFormGroup.controls['extensionsQuantity'].setValue(billingExtensionsLicense.value['number']);
      this.billingFormGroup.controls['administratorsQuantity'].setValue(billingAdministratorsLicense.value['number']);
      this.billingFormGroup.controls['usersQuantity'].setValue(billingUsersLicense.value['number']);
      if (billingExtensionsLicense.expiration !== 0) {
        this.billingFormGroup.controls['licenseExpiration']
          .patchValue(new Date(billingExtensionsLicense.expiration));
      }
    }
  }

  findLicense(name: string, licenses: Array<License>): License {
    return licenses.find((license, idx, obj) => {
      return (license.name === name);
    });
  }

  onValueChanges(data?: any) {
    const form = this.formGroup;

    this.formErrors = this.validateFields(this.formGroup, this.validationMessages);

    console.log(`id value: ${form.get('id').value}`);

    this.cs.verifyExists(form.get('id').value).subscribe(
      (result) => {
        this.invalidId = false;
        if (result && !this.editing) {
          if (!this.formErrors['id']) {
            this.formErrors['id'] = '';
          }
          this.invalidId = true;
          this.formErrors['id'] += 'Id já utilizada';
        }
      }
    );

    for (const error in this.formErrors) {
      if (error !== '""') {
        console.log(`Error:${JSON.stringify(this.formErrors[error])}`);
      }
    }
  }

  onLicenseValueChanges(data?: any) {

    const form = this.licenseFormGroup;

    this.licenseEnabled = form.get('enableLicense').value;

    this.licenseFormErrors = this.validateFields(form, this.validationMessages);
  }

  onBillingValueChanges(data?: any) {

    const form = this.billingFormGroup;

    this.billingEnabled = form.get('enableBilling').value;

    this.billingFormErrors = this.validateFields(form, this.validationMessages);
  }

  validateFields(form: FormGroup, validationMessages: any): any {

    const result = {};

    for (const field in validationMessages) {
      if (validationMessages.hasOwnProperty(field)) {
        const control = form.get(field);
        if (control && control.dirty && !control.valid) {
          const messages = validationMessages[field];
          for (const key in control.errors) {
            if (control.errors.hasOwnProperty(key)) {
              console.log(`Error: '${key}'`);
              if (!result[field]) {
                result[field] = '';
              }
              result[field] += messages[key] + '. ';
            }
          }
        }
      }
    }
    for (const error in result) {
      if (result.hasOwnProperty(error) && error !== '""') {
        console.log(`Error:${JSON.stringify(result[error])}`);
      }
    }
    return result;
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/customer/customer-edit/customer-edit.component.ts